import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'
import countries from './countries'
import species from './species'
import seriales from './seriales'
import ecosystems from './ecosystems'
import reserves from './reserves'
import transactions from './transactions'
import profiles from './profiles'
import mapStates from './mapStates'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    reservaAct: null,
    reloadMap: true,
    bigMap: true
  },
  actions: {
    async initialize ({ dispatch }) {
      await dispatch('auth/initialize', null, {root: true})
      Promise.all([
        dispatch('countries/initialize', null, {root: true}),
        dispatch('species/initialize', null, {root: true}),
        dispatch('ecosystems/initialize', null, {root: true}),
        dispatch('reserves/initialize', null, {root: true}),
        dispatch('transactions/initialize', null, {root: true})
      ])
    }
  },
  modules: {
    auth,
    countries,
    species,
    seriales,
    ecosystems,
    reserves,
    transactions,
    profiles,
    mapStates
  },
  getters: {
    activeReserve: (state) => {
      return state.reserves.items
    },
    userTrees: (state) => (userId) => {
      var count = 0
      for (const reserveId in state.reserves.items) {
        const seeds = state.reserves.items[reserveId].seeds;
        if (seeds) {
          for (const key in seeds) {
            const seed = seeds[key];
            if (seed.planted && seed.planted.ownerId == userId) {
              count += 1
            }
          }
        }
      }
      return count
    },
    activeReserves: (state) => {
      var response = []
      const itemsObj = state.reserves.items
      if (itemsObj) {
        for (const key in itemsObj) {
          const item = itemsObj[key];
          if (item.active) {
            response.push(item)
          }
        }
      }
      return response
    },
    reserveUserSeeds: state => id => {
      const user = state.auth.user
      if (!user || !state.reserves.items[id] || !state.reserves.items[id].seeds) {
        return []
      }
      const seeds = state.reserves.items[id].seeds
      var response = []
      for (const key in seeds) {
        const seed = seeds[key];
        if (!seed.planted && seed.ownerId == user.uid) {
          response.push(seed)
        }
      }
      return response
    },
    reserveUnplantedSeeds: state => id => {
      if (!state.reserves.items[id] || !state.reserves.items[id].seeds) {
        return []
      }
      var reservedSeeds = [] 
      state.transactions.items.forEach((transaction) => {
        if (transaction.reserveId === id && transaction.state === 'unpaid') {
          const seeds = transaction.seeds;
          if (seeds) {
            reservedSeeds = reservedSeeds.concat(seeds);
          }
        }
      })
      const seeds = state.reserves.items[id].seeds
      var response = []
      for (const key in seeds) {
        const seed = seeds[key];
        if (!seed.planted && !seed.ownerId && !reservedSeeds.includes(seed.id)) {
          response.push(seed)
        }
      }
      return response
    },
    reserveUnplantedSeedsTunel: (state) => (id, seedsT) => {
      var semillas = []
      let cont = 0;
      for(let i=0;i < state.reserves.items[id].seeds.length; i++){
        if(state.reserves.items[id].seeds[i].ownerId === null){
          semillas = semillas.concat(state.reserves.items[id].seeds[i])
          cont = cont+1;
        }
         if(cont == seedsT){
          break
        }
      }
      return semillas
    },
    errorMessage: (state) => {
      return state.auth.profile
    },
    userUid: (state) => {
      return state.auth.user ? state.auth.user.uid : null
    },
    unplantedTrees:  state => id => {
      var arboles = []
    
      for(let i=0;i < state.reserves.items[id].trees.length; i++){
          arboles = arboles.concat(state.reserves.items[id].trees[i])
      }
      return arboles
    },
    userSeeds: state => id => {
      var semillas = []
    
      for(let i=0;i < state.reserves.items[id].seeds.length; i++){
        if(state.reserves.items[id].seeds[i].ownerId === state.auth.user.uid){
          semillas = semillas.concat(state.reserves.items[id].seeds[i])
        }
      }
      return semillas
    }
  },
  mutations: {
    reservaActiva: (state, payload) => {
      state.reservaAct = payload;
    },
    recargarMapa: (state) => {
      if(state.reloadMap) {
        state.reloadMap = false
      } else {
        state.reloadMap = true
      }
    },
    bigMap: (state) => {
      if(state.bigMap && state.reservaAct !== null) {
        state.bigMap = false
      } else {
        state.bigMap = true
      }
    },
    setBigMap: (state, payload) => {
      state.bigMap = payload
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js